export default __webpack_public_path__ + "static/media/PS1_Exploded-0.25ETHM.f545229e.mp4";